import React, { Component } from "react";
import { Segment } from "semantic-ui-react";

import WinnersTable from "../../components/tables/WinnersTable";
import PickWinner from "./EventPickWinner";
import request from "../../utils/request";
import { AppContext } from "../../utils/context";

class WinnersTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errorMessage: "",
      errorShow: false,
      successMessage: "",
      successShow: false,
      eventId: props.match.params.id,
      event: false,
      eventOptions: [],
      events: [],
      poll: false,
      winnersList: [],
      prices: [],
      priceOptions: [],
      prizes: [],
      prizeOptions: [],
      summary: []
    }
  }
  componentDidMount = () => {
    this.init();
  };
  componentDidUpdate = prevProps => {
    // Typical usage (don't forge`t to compare props):
    if (this.props.eventId !== prevProps.eventId) {
      this.setState({ eventId: this.props.eventId }, this.init);
    }
  };
  handleChange = (e, { name, value }) => this.setState({ [name]: value });
  init = async () => {
    this.setState({ isLoading: true });
    if (this.state.eventId === 0) return false;
    let event = await request.get(this, `api:/event/${this.state.eventId}`, {});
    let winners = await request.get(this, `api:/event/${this.state.eventId}/winners`, { ts: Date.now() });
    let summary = await request.get(this, `api:/event/${event.id}/summary`, { ts: Date.now() });
    this.setWinners(winners);
    this.setState({ event: event, summary: summary });
  };
  setPriceOptions = result => this.setState({ priceOptions: result });
  setWinners = result => {
    this.setState({ isLoading: true });
    let prizes = [];
    let winners = [];
    result.data.map((value, index) => {
      if (value.is_secondary === 1) {
        if (value.number === null) {
          prizes.push({ value: value.id, text: value.prize });
        }
        winners.push(value);
      } else if (value.draw_at === null) {
        prizes.push({ value: value.id, text: value.prize });
        winners.push(value);
      } else {
        if (result.data.length === 1 && value.is_grand && value.game_id === 3) {
          value.prize = +value.prize + +value.jackpot;
        }
        winners.push(value);
      }
      return value;
    });
    this.setState({ winnersList: winners, isLoading: false });
  };
  render() {
    const { winnersList, event, summary, isLoading } = this.state;
    return (
      <Segment basic>
        <Segment basic textAlign="right">
          <PickWinner 
            eventId={this.props.eventId} 
            winners={winnersList} 
            summary={summary} 
            close={this.init}
            event={event}
          />
        </Segment>
        <WinnersTable 
          winners={winnersList} 
          game={event ? event.game_id : 0} 
          language={this.context.language} 
          init={this.init} 
          isLoading={isLoading} 
        />
      </Segment>
    );
  }
}

WinnersTab.contextType = AppContext;

export default WinnersTab;
